import React, { useState } from "react";
import { CorporateSidebarItems } from "./SidebarItems";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

export const CorporateSidebar = ({ isOpen, HandleOpen }) => {
  const [preRecruit, setPreRecruit] = useState(true);

  const HandleClick = () => {
    HandleOpen();
  };

  return (
    <div
      className={`fixed top-0 left-0 z-40 h-screen p-4 px-2 overflow-y-auto duration-200 bg-gray-900 text-white ${
        isOpen ? "w-48" : "w-14"
      }`}
    >
      <div
        onClick={HandleClick}
        className="flex items-center absolute top-10 right-0 cursor-pointer"
      >
        <div className="bg-[#fffefe] rounded-l-lg h-6 w-6 flex justify-center items-center">
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4 text-black"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          )}
        </div>
      </div>

      <div className="py-4">
        <ul className="space-y-4">
          <li className="flex items-center cursor-pointer rounded-lg hover:bg-[#424242] my-2"></li>

          <div
            className={`${
              preRecruit ? (isOpen ? "block ml-2" : "block") : "hidden"
            }`}
          >
            {CorporateSidebarItems.map((data, index) => (
              <Link key={index} to={data.link || "#"}>
                <li className="flex items-center rounded-lg hover:bg-[#424242] my-2">
                  <span className="inline-flex items-center flex-shrink-0 p-1.5">
                    {data.icon}
                  </span>
                  <div
                    className={`duration-300 overflow-hidden block ${
                      isOpen ? "block" : "hidden"
                    }`}
                  >
                    <span className="origin-left truncate">{data.text}</span>
                  </div>
                </li>
              </Link>
            ))}
          </div>
        </ul>
      </div>
    </div>
  );
};
